import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon, ChartBarIcon } from '@heroicons/react/24/outline';
import { useAuth } from '@/hooks/useAuth';
import toast from 'react-hot-toast';

const AnalyticsPage: React.FC = () => {
  const { user } = useAuth();
  const isSuperAdmin = user?.role === 'SUPER_ADMIN';
  
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">
            {isSuperAdmin ? 'Platform Analytics' : 'School Analytics'}
          </h1>
          <p className="text-gray-600 mt-1">
            {isSuperAdmin 
              ? 'Comprehensive analytics and insights across all school tenants'
              : 'Analytics and insights for your school'
            }
          </p>
        </div>
        <button 
          onClick={() => toast.success('Export analytics coming soon!')}
          className="btn btn-primary"
        >
          <EyeIcon className="h-4 w-4 mr-2" />
          Export Report
        </button>
      </div>

      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="dashboard-card"
      >
        <div className="text-center py-12">
          <ChartBarIcon className="mx-auto h-12 w-12 text-gray-400" />
          <h3 className="mt-4 text-lg font-medium text-gray-900">
            {isSuperAdmin ? 'Platform Analytics Dashboard' : 'School Analytics Dashboard'}
          </h3>
          <p className="mt-2 text-gray-500 max-w-md mx-auto">
            {isSuperAdmin 
              ? 'This page will display comprehensive analytics including usage statistics, performance metrics, user engagement, and financial insights across all tenants.'
              : 'This page will display school-specific analytics including student attendance, academic performance, transport utilization, and school operations insights.'
            }
          </p>
          <button 
            onClick={() => toast.success('Coming soon!')}
            className="mt-4 btn btn-primary"
          >
            View Implementation Plan
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default AnalyticsPage;